import { Button, Card, Checkbox, Space } from 'antd';
import { useState } from 'react';

export type CheckboxFilterDropdownProps = {
  defaultValue?: string[];
  options: Array<{ label: string; value: string }>;
  onApplyFilter: (values: string[]) => void;
};

const CheckboxFilterDropdown = (props: CheckboxFilterDropdownProps) => {
  const { options, onApplyFilter, defaultValue } = props;
  const [values, setValues] = useState<string[]>(defaultValue || []);

  const onSelectAll = () => setValues(options.map((option) => option.value));
  const onClearAll = () => setValues([]);
  const onApply = () => onApplyFilter(values);

  return (
    <Card title="Select" size="small">
      <Checkbox.Group value={values} onChange={(v) => setValues(v as string[])} className="flex flex-col" options={options} />
      <Space.Compact className="mt-2">
        <Button onClick={onClearAll}>Clear All</Button>
        <Button onClick={onSelectAll}>Select All</Button>
        <Button type="primary" onClick={onApply}>
          Apply
        </Button>
      </Space.Compact>
    </Card>
  );
};

export default CheckboxFilterDropdown;
